import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderDeliveryStatus } from "@WhiteCap/Store/Service/OrderDeliveryStatus";

import { Draft } from "immer";

export interface OrderDataState {
    isLoading: boolean;
    OrderData?: OrderDeliveryStatus;
}

const initialState: OrderDataState = {
    isLoading: false,
    OrderData: undefined,
};
const OrderDataReducer = {
    "Custom/OrdersData/BeginLoadOrderDat": (draft: Draft<OrderDataState>) => {
        draft.isLoading = true;
    },
    "Custom/OrdersData/CompletedLoadOrderData": (
        draft: Draft<OrderDataState>,
        action: {
            result: OrderDeliveryStatus;
        },
    ) => {
        draft.OrderData = action.result;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, OrderDataReducer);
